/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbSharedSearchRedirectNotice_searchBrowse$ref: FragmentReference;
export type SbSharedSearchRedirectNotice_searchBrowse = {|
  +pageType: ?string,
  +spellCheck: ?{|
    +newQuery: ?string,
    +oldQuery: ?string,
    +redirect: ?{|
      +redirectFrom: ?string
    |},
  |},
  +$refType: SbSharedSearchRedirectNotice_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbSharedSearchRedirectNotice_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "spellCheck",
      "storageKey": null,
      "args": null,
      "concreteType": "SpellcheckSuggestions",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "newQuery",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "oldQuery",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "redirect",
          "storageKey": null,
          "args": null,
          "concreteType": "SpellcheckSuggestionsRedirected",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "redirectFrom",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ed7d2d9968b4bbcd6be188fbaf997339';
module.exports = node;
